import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function PaymentCancel() {
  const [sp] = useSearchParams();
  const appt = sp.get("appointment_id");
  return (
    <div className="max-w-lg mx-auto text-center py-16">
      <div className="w-16 h-16 rounded-full bg-[#fffbeb] text-[#d97706] flex items-center justify-center mx-auto mb-6"><AlertCircle size={32}/></div>
      <h1 className="cm-h2">Payment cancelled</h1>
      <p className="cm-body mt-3 text-sm">No charge was made. You can try again when you're ready.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/patient/appointments" className="cm-btn-outline" data-testid="pay-cancel-appts">Back to appointments</Link>
        <Link to="/find-care" className="cm-btn-primary" data-testid="pay-cancel-search">Browse doctors</Link>
      </div>
    </div>
  );
}
